import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "ags_cookie_consent_v1";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const t = setTimeout(() => setVisible(true), 1100);
        return () => clearTimeout(t);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const persist = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      role="dialog"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-50 bg-white border-t border-[#0E2A57]/15 shadow-[0_-12px_40px_rgba(14,42,87,0.06)]"
    >
      <div className="container-ags py-5 md:py-6 flex flex-col md:flex-row md:items-center gap-5 md:gap-10">
        <div className="flex-1 min-w-0">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#2BB6E5] font-medium mb-1.5">
            Cookie Notice
          </div>
          <p className="text-[13px] md:text-sm text-[#475569] leading-relaxed max-w-3xl">
            We use essential cookies to operate this website and anonymous analytics to improve it.
            Read more in our{" "}
            <Link to="/cookies" className="text-[#0E2A57] underline decoration-[#2BB6E5] decoration-2 underline-offset-2 hover:text-[#050B14]">
              Cookie Policy
            </Link>.
          </p>
        </div>
        <div className="flex flex-wrap gap-2 items-center">
          <button
            onClick={() => persist("essential")}
            data-testid="cookie-essential"
            className="bg-transparent border border-[#0E2A57]/30 text-[#0E2A57] hover:bg-[#0E2A57]/5 px-5 py-2.5 text-xs font-semibold tracking-wide uppercase transition-colors"
          >
            Essential only
          </button>
          <button
            onClick={() => persist("all")}
            data-testid="cookie-accept-all"
            className="bg-[#0E2A57] text-white hover:bg-[#050B14] px-5 py-2.5 text-xs font-semibold tracking-wide uppercase transition-colors"
          >
            Accept all
          </button>
          <button
            onClick={() => persist("dismissed")}
            aria-label="Dismiss cookie notice"
            data-testid="cookie-dismiss"
            className="text-[#475569] hover:text-[#0E2A57] p-2 transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
